import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardHeader, CardBlock } from 'reactstrap'
import { FaRefresh } from 'react-icons/lib/fa'
import ConfirmButton from '../../components/ConfirmButton'
import styles from './CacheSettings.scss'

const CacheSettings = props =>
  <div className={styles.CacheSettings}>
    <Card>
      <CardHeader>Clear cache</CardHeader>
      <CardBlock>
        <p>Manually clear the site data cache if data is stale. Note that CMS content updates automatically clear related items in the cache.</p>
        <ConfirmButton title='Clear cache' message='Are you sure you want to clear the cache for all pages?'
          onConfirm={props.onFlush}
          color='danger'><FaRefresh /> Clear Cache</ConfirmButton>
      </CardBlock>
    </Card>
  </div>

CacheSettings.propTypes = {
  onFlush: PropTypes.func
}

export default CacheSettings



// WEBPACK FOOTER //
// ./src/components/CacheSettings/CacheSettings.js